import React, { useEffect, useState } from "react";
import { auth, firestore } from "../../../firebaseConfig";
import {
  collection,
  doc,
  DocumentData,
  getDoc,
  setDoc 
} from "firebase/firestore"; // Import Firestore functions
import { User as FirebaseUser, signOut } from "firebase/auth"; // Import the User type and signOut from Firebase Authentication
import { useNavigate } from "react-router-dom";
import * as S from "./styles"; // Import your styled-components styles

const UserProfile: React.FC = () => {
  const [user, setUser] = useState<DocumentData | null>(null);
  const [firebaseUser, setFirebaseUser] = useState<FirebaseUser | null>(
    null
  ); // Track Firebase user
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    // Use Firebase Auth to get the currently logged-in user
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        // User is signed in
        setFirebaseUser(currentUser);
  
        // Use Firebase Firestore to fetch user details from the database
        const db = firestore;
  
        // Reference the "users" collection and the document for the current user
        const userCollection = collection(db, "users");
        const userDoc = doc(userCollection, currentUser.uid);
  
        getDoc(userDoc)
          .then((docSnap) => {
            if (docSnap.exists()) {
              // Check if the document exists
              setUser(docSnap.data());
            } else {
              // No document found for the user, create a new one
              setDoc(userDoc, {
                firstName: currentUser.displayName,
                surname: "", // You might want to split the displayName into first and last names
                email: currentUser.email,
                // Add any additional fields as needed
              })
                .then(() => {
                  console.log("User document created successfully!");
                })
                .catch((error: Error) => {
                  console.error("Error getting user data:", error);
                });
                
            }
          })
          .catch((error) => {
            console.error("Error getting user data:", error);
          });
      } else {
        // User is signed out
        setFirebaseUser(null);
        setUser(null);
      }
    });
  
    // Clean up the observer when the component unmounts
    return () => unsubscribe();
  }, []);
  

  const handleLogOut = async () => {
    try {
      await signOut(auth);
      // User is logged out
      console.log("User logged out successfully!");
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  return (
    <S.UserProfileContainer>
      <S.Navigation>
      <S.ProfileDetails>
        <h2>User Profile</h2>
        {firebaseUser && user ? (
          <div>
            <p>Name: {user.firstName} {user.surname}</p>
            <p>Email: {firebaseUser.email}</p>
            {/* Add more user details as needed */}
          </div>
        ) : (
          <div>
            <p>User is not signed in.</p>
            <button onClick={() => navigate("/login")}>Log In</button>
          </div>
        )}
      </S.ProfileDetails>
        <ul>
          <li>Overview</li>
          <li>Recommended For You</li>
          <li>Wishlist</li>
          <li>Account</li>
          <li>Address Book</li>
          <li>Saved Cards</li>
        </ul>
      </S.Navigation>
      
      <S.ProfileDetails>
          <div>
          <button onClick={handleLogOut}>Log Out</button>
          </div>
      </S.ProfileDetails>
    </S.UserProfileContainer>
  );
};

export default UserProfile;